import { render, staticRenderFns } from "./KeywordSuggestions.vue?vue&type=template&id=7df626a4&"
import script from "./KeywordSuggestions.vue?vue&type=script&lang=js&"
export * from "./KeywordSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSuggestions.vue?vue&type=style&index=0&id=7df626a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports